import styled from 'styled-components'

const SingleLabel = styled.div`
  width: 100%;
  white-space: nowrap;
`

export default SingleLabel
